import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const Fotter = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-amber50 dark:bg-gray-900 ">
      <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-5 grid grid-cols-1">
          <div className="md:flex md:justify-between">
            <div className="mb-6 md:mb-0">
              <Link to="/" className="flex items-center">
                <img
                  src={require("../assets/images/teeth.jpg")}
                  className="h-8 mr-3 rounded-full"
                  alt={t("DentalClinicLogo")}
                />
                <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
                  {t("DentalClinic")}
                </span>
              </Link>
            </div>
          </div>
          <div className="lg:pt-0 pt-5">
            <span className="text-xl text-center">Support</span>
            <div className="mt-5">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://t.me/dentalclinicsystemsupport"
                className="text-gray-700 hover:text-gray-900 dark:hover:text-white flex flex-row gap-2"
              >
                <svg
                  className="w-6 h-6"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="4 5 8 19"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18.384,22.779c0.322,0.228 0.737,0.285 1.107,0.145c0.37,-0.141 0.642,-0.457 0.724,-0.84c0.869,-4.084 2.977,-14.421 3.768,-18.136c0.06,-0.28 -0.04,-0.571 -0.26,-0.758c-0.22,-0.187 -0.525,-0.241 -0.797,-0.14c-4.193,1.552 -17.106,6.397 -22.384,8.35c-0.335,0.124 -0.553,0.446 -0.542,0.799c0.012,0.354 0.25,0.661 0.593,0.764c2.367,0.708 5.474,1.693 5.474,1.693c0,0 1.452,4.385 2.209,6.615c0.095,0.28 0.314,0.5 0.603,0.576c0.288,0.075 0.596,-0.004 0.811,-0.207c1.216,-1.148 3.096,-2.923 3.096,-2.923c0,0 3.572,2.619 5.598,4.062Zm-11.01,-8.677l1.679,5.538l0.373,-3.507c0,0 6.487,-5.851 10.185,-9.186c0.108,-0.098 0.123,-0.262 0.033,-0.377c-0.089,-0.115 -0.253,-0.142 -0.376,-0.064c-4.286,2.737 -11.894,7.596 -11.894,7.596Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span className="">On Telegram</span>
              </a>
            </div>
          </div>
        </div>
        
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
            © ፳፻፲፮ - 2023/24{" "}
            <Link to="/" className="hover:underline">
              {t("DentalClinic")}
            </Link>
            &nbsp;{t("AllRightResereved")}
          </span>
          <button onClick={() => window.scrollTo(0, 0)}>Go To <ArrowUpwardIcon /></button>
        </div>
      </div>
    </footer>
  );
};

export default Fotter;
